import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Login from "./Login";
import { Toaster } from "sonner";

createRoot(document.getElementById("tmt-plus-login")!).render(
	<StrictMode>
		<Login/>
		<Toaster richColors />
	</StrictMode>,	
);